import React, { useState, useEffect, useRef } from 'react'
import Box from '@mui/material/Box'

import Avatar from '@mui/material/Avatar'
import Skeleton from '@mui/material/Skeleton'
import { useStyles } from './styles/index.styles'

import UploadOutlinedIcon from '@mui/icons-material/UploadOutlined'

import AttachmentService from '../../../services/AttachmentService'
import secureLocalStorage from 'react-secure-storage'
import colors from '../../styles/colors'

import { toast } from 'react-toastify'
import { useModal } from '../../hooks/useModal'
import { useSocket } from '../../../services/hooks/socketHook'

const avatarCache = new Map<string, string>()

export default function AvatarHiplade({
  nameUser,
  size,
  theme,
  upload,
  id,
  source,
  only,
  onlyInitials,
}: any) {
  const classes = useStyles()

  const { handleOpenModal, dataModal, onResetModal } = useModal();

  const [avatar, setAvatar] = useState('')
  const [src, setSrc] = useState('')
  const [loading, setLoading] = useState(!source && !onlyInitials)
  const [uploadClicked, setUploadClicked] = useState(false);


  let auth_user_id = secureLocalStorage.getItem('id')

  const confirmationUpload = dataModal.displayName === 'uploadConfirmationModal'
  const inputRef = useRef<HTMLInputElement>(null);

  if (id != '') {
    auth_user_id = id
  }

   /**
   * Utilização de WEBSOCKET
   */
   /*useSocket({
     callBack: (payload) => {
      setSrc(payload.avatar_pic_static_url)
     },
     channel: 'user.' + auth_user_id, // Nome do privateChannel na classe do MANAGER
     event: '.App\\Events\\UserUpdateChannel' // Nome de classe caminho completo
   });
   /**
    *  END WEBSOCKET
    */

  const createNameAvatar = () => {
    const name = nameUser?.toString()
    let arrName = name?.split(' ')
    let nameAvatar = ''

    if (arrName && arrName?.length > 0) {
      nameAvatar =
        arrName.length > 1
          ? arrName[0].substring(0, 1) +
            arrName[arrName.length - 1].substring(0, 1)
          : arrName[0].substring(0, 1)
      nameAvatar = nameAvatar.toUpperCase()
      setAvatar(nameAvatar)
    }
  }

  const loadAvatar = (signal: AbortSignal) => {
    const cacheKey = `users-${id}-avatar-upload-pic`
    const cached = avatarCache.get(cacheKey)
    if (cached) {
      setSrc(cached)
      setLoading(false)
      return
    }
    AttachmentService.get('users', id, 'avatar-upload-pic', signal)
      .then((response) => {
        if (signal.aborted) return
        if (response.data && response.data.length > 0) {
          const url = response.data[0].url
          avatarCache.set(cacheKey, url)
          setSrc(url)
        }
        setLoading(false)
      })
      // Usuário sem foto é caso normal (a rota responde 404): cai no fallback de
      // iniciais, não é erro que mereça toast.
      .catch(() => {
        if (!signal.aborted) setLoading(false)
      })
  }

  const sizeAvatar = (size: any) => {
    switch (size) {
      case 'mini':
        return '24px'
      case 'small':
        return '40px'
      case 'medium':
        return '64px'
      case 'large':
        return '98px'
      case 'extra-large':
        return '252px'
      default:
        return '64px'
    }
  }

  const sizeConfig = () => {
    return {
      mr: 2,
      width: `${sizeAvatar(size)}`,
      height: `${sizeAvatar(size)}`,
      fontSize: `${fontAvatar(size)}`,
    }
  }

  const fontAvatar = (size: any) => {
    if (size == 'mini') {
      return '13px !important'
    }

    if (size == 'extra-large') {
      return '150px !important'
    }
  }

  const themeAvatar = (theme: any) => {
    if (theme == 'gray') {
      return classes.avatarGray
    } else {
      return classes.avatar
    }
  }

  const handleChange = async (e) => {
    setUploadClicked(false)
    // `secureLocalStorage.getItem` devolve um tipo largo; object_id precisa ser
    // string|number. Sem id válido não há o que enviar — guarda em vez de cast.
    const objectId =
      typeof auth_user_id === 'string' || typeof auth_user_id === 'number'
        ? auth_user_id
        : null
    if (objectId === null) return

    await AttachmentService.upload({
      feature: 'users',
      object_id: objectId,
      field_name: e.target.name,
      file: e.target.files[0],
      file_type: 'image',
      multiple: 'false',
    })
      .then((response) => {
        avatarCache.set(`users-${auth_user_id}-avatar-upload-pic`, response.data.url)
        setSrc(response.data.url)
        toast(response.data.register_face, {
          type: 'info',
        })
        toast(response.data.Msg, {
          type: 'success',
        })
      })
      .catch((e: any) => {
        toast(e?.response?.data?.Error, {
          type: 'error',
        })
        //location.reload();
      })

  }



  useEffect(() => {
    createNameAvatar()
  }, [nameUser])

  useEffect(() => {
    if (onlyInitials) {
      setLoading(false)
      return
    }
    if (source) {
      setSrc(source)
      setLoading(false)
      return
    }
    const controller = new AbortController()
    setLoading(true)
    loadAvatar(controller.signal)
    return () => controller.abort()
  }, [id, source, onlyInitials])

  useEffect(() => {
    if (confirmationUpload && uploadClicked && inputRef.current) {
      inputRef.current.click();
    }
  }, [uploadClicked, confirmationUpload])


  useEffect(() => {
    if (dataModal.btnSaveModalClicked) {
      setUploadClicked(true)
    }
  }, [uploadClicked, dataModal.btnSaveModalClicked])

  if(only) {
    if (loading) {
      return <Skeleton variant="circular" sx={sizeConfig()} />
    }
    return (
      <Avatar
        alt="Avatar"
        sx={sizeConfig}
        className={themeAvatar(theme)}
        src={src}
      >
        {avatar}
      </Avatar>
    )
  }

  return (
    <Box>
      <Box className={classes.profileUpload} sx={sizeConfig}>
        {loading ? (
          <Skeleton variant="circular" sx={sizeConfig()} />
        ) : (
          <Avatar
            alt="Avatar"
            sx={sizeConfig}
            className={themeAvatar(theme)}
            src={src}
          >
            {avatar}
          </Avatar>
        )}

        {upload ? (
          <Box onClick={() => handleOpenModal({ displayName: 'uploadConfirmationModal'})}>
            {uploadClicked && (
              <input
                ref={inputRef}
                accept="image/*"
                className={classes.displayNone}
                id="avatar-upload-pic"
                name="avatar-upload-pic"
                type="file"
                onChange={(e) => handleChange(e)}
              />
            )}
            <label htmlFor="avatar-upload-pic">
              <UploadOutlinedIcon
                className={classes.uploadIcon}
                sx={{ fontSize: sizeConfig }}
              />
            </label>
          </Box>
        ) : (
          ''
        )}
      </Box>
    </Box>
  )
}
